module.exports = __webpack_public_path__ + "static/media/API_Status.99ca274f.png";